export enum TicketUsageTypes {
    REGULAR = 1,
    DAY_PASS = 2,
    TRACK_PASS = 3,
    WHOLE_EVENT_PASS = 4
}